const YEARS_BACK = 100;
const YEARS_FORWARD = 10;

export const getYearOptions = (displayedYear: number): number[] => {
  const currentYear = new Date().getFullYear();
  const firstYear = Math.min(currentYear - YEARS_BACK, displayedYear);
  const lastYear = Math.max(currentYear + YEARS_FORWARD, displayedYear);

  return Array.from({ length: lastYear - firstYear + 1 }, (_, index) => firstYear + index);
};
